import { render } from "./AktuellesList.vue?vue&type=template&id=79505fb0"
import script from "./AktuellesList.vue?vue&type=script&lang=js"
export * from "./AktuellesList.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__